export const state = {
    modelsIds: [],
};

export function profabCompareRemoveFromArray(idToRemove){
    state.modelsIds = state.modelsIds.filter(function(item) {
      return item.id != idToRemove;
    });
}